<template>
  <div class="flex -mx-3 text-sm">
    <div class="flex-1 px-3">{{ $t('name') | capitalize }} / url</div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratHeader',
};
</script>
